import React, { useState } from "react";

const LogoUploadComponent = ({ onLogoUpload }) => {
  const [logoSrc, setLogoSrc] = useState(null);

  const handleLogoUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setLogoSrc(reader.result);
        onLogoUpload(file);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Upload Clinic Logo:
      </label>
      <input
        type="file"
        onChange={handleLogoUpload}
        className="form-input rounded-md shadow-sm"
        accept="image/*"
      />
      {logoSrc && (
        <div className="mt-4">
          <img
            src={logoSrc}
            alt="Clinic Logo Preview"
            className="max-w-xs max-h-20 object-contain"
          />
        </div>
      )}
    </div>
  );
};

export default LogoUploadComponent;
